import { useEffect, useState } from 'react'

import { addScriptToPage } from '../../lib/helpers/addScriptToPage'

// Extend Window interface for custom globals
declare global {
  interface Window {
    geofeed?: (opts: {
      country: string | number
      state: string | number
    }) => void
  }
}

export type FooterPrivacyLinkOptions = {
  alwaysShowOptOutLink?: boolean
}

export const useFooterPrivacyLink = (
  options: FooterPrivacyLinkOptions = {}
) => {
  const [showOptOut, setShowOptOut] = useState(false)
  const host = window.location.hostname
  const pathname = window.location.pathname
  const isNewsroomPath = /\/newsroom/.test(pathname)
  const isEnabledForHost =
    (/localhost/.test(host) ||
      /www\.qa\.ameriprise\.com/.test(host) ||
      /www\.ameriprise\.com/.test(host) ||
      /www\.qa\.ameripriseadvisors\.com/.test(host) ||
      /www\.ameripriseadvisors\.com/.test(host)) &&
    !isNewsroomPath

  const alwaysShowOptOutLink = options.alwaysShowOptOutLink
  useEffect(() => {
    if (alwaysShowOptOutLink) {
      return
    }
    window.geofeed = (opts: {
      country: string | number
      state: string | number
    }) => {
      const country = opts.country.toString()
      const state = opts.state.toString()
      if (state === 'CA' && country === 'US') {
        setShowOptOut(true)
      }
    }
    if (isEnabledForHost) {
      addScriptToPage({
        src: 'https://geolocation.onetrust.com/cookieconsentpub/v1/geo/location/geofeed'
      })
    }
  }, [showOptOut, isEnabledForHost, alwaysShowOptOutLink])

  if (alwaysShowOptOutLink) {
    return true
  }
  if (!isEnabledForHost) {
    return false
  }

  return showOptOut
}
